import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Page, Stepper } from '../components/Layout'
import { Aviso, ErrorBox, Money } from '../components/ui'
import { apiPost } from '../lib/api'
import { getFunnel, setFunnel } from '../lib/funnel'

interface PropostaResp {
  proposta_id: string
  valor_entrada: number
  gatilho_entrada: string
  percentual_exito: number
  faixa_estimada_ilustrativa: { min: number; max: number }
  aviso: string
}

export default function Proposta() {
  const nav = useNavigate()
  const [erro, setErro] = useState<string | null>(null)
  const [p, setP] = useState<PropostaResp | null>(null)

  useEffect(() => {
    const f = getFunnel()
    if (!f.lead_id) {
      setErro('Sessão de triagem não encontrada. Refaça a triagem.')
      return
    }
    apiPost<PropostaResp>('/api/proposta/gerar', { lead_id: f.lead_id, triagem_id: f.triagem_id })
      .then((resp) => {
        setP(resp)
        setFunnel({ proposta_id: resp.proposta_id, valor_entrada: resp.valor_entrada })
      })
      .catch((e) => setErro((e as Error).message))
  }, [])

  return (
    <Page>
      <Stepper step={1} />
      <h1 className="text-2xl font-semibold text-pfa-navy">Sua proposta</h1>
      <ErrorBox message={erro} />
      {p && (
        <div className="mt-4 grid gap-6 md:grid-cols-2">
          <div className="card">
            <h2 className="font-semibold text-pfa-navy">Entrada (você paga só depois)</h2>
            <p className="mt-1 text-3xl text-pfa-slate/60 line-through decoration-2">
              <Money value={p.valor_entrada} />
            </p>
            <p className="mt-2 text-sm text-pfa-slate">
              Equivale a 3× a sua parcela mensal. <strong>Você não paga nada agora.</strong> Essa entrada só é cobrada se
              a Justiça mandar pausar as suas parcelas — e só alguns dias depois disso.
            </p>
          </div>

          <div className="card">
            <h2 className="font-semibold text-pfa-navy">Honorários de êxito</h2>
            <p className="mt-1 text-3xl">{p.percentual_exito}%</p>
            <p className="mt-2 text-sm text-pfa-slate">
              Você só paga este percentual <strong>depois de receber</strong> o valor da ação — e somente sobre o que
              você de fato recebeu.
            </p>
          </div>

          <div className="md:col-span-2">
            <Aviso>{p.aviso}</Aviso>
            <button className="btn-accent mt-6" onClick={() => nav('/contratar')}>
              Quero contratar
            </button>
          </div>
        </div>
      )}
    </Page>
  )
}
